(function () {
  // Gallery images after the first one load once the page is idle, so they do not compete with the main image.
  function run() {
    document.querySelectorAll('img[data-defer-src]').forEach(function (img) {
      if (img.dataset.deferSrcset) img.srcset = img.dataset.deferSrcset;
      img.src = img.dataset.deferSrc;
      img.removeAttribute('data-defer-src');
      img.removeAttribute('data-defer-srcset');
    });
  }

  function schedule() {
    var idle = window.requestIdleCallback || function (cb) { return setTimeout(cb, 1); };
    idle(function () { setTimeout(run, 500); });
  }

  if (document.readyState === 'complete') schedule();
  else window.addEventListener('load', schedule, { once: true });

  ['touchstart', 'pointerdown', 'keydown', 'wheel'].forEach(function (name) {
    window.addEventListener(name, run, { once: true, passive: true });
  });

  // new gallery nodes (for example after a variant change) are loaded straight away
  new MutationObserver(function () {
    if (document.readyState === 'complete') run();
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
